module.exports = __webpack_public_path__ + "img/login.6bf2e713.jpg";